// extracted by mini-css-extract-plugin
export var defaultWrapper = "_h9-3";
export var downloadButton = "_h9-4";
export var fileContainer = "_h9-9 _h9-7";
export var fileContainerBase = "_h9-7";
export var fileContainerBaseSm = "_h9-a _h9-7";
export var fileContainerFixedHeight = "_h9-8 _h9-7";
export var fileContainerFixedHeightSm = "_h9-c _h9-a _h9-7";
export var fileContainerSm = "_h9-b _h9-a _h9-7";
export var fileInfo = "_h9-5";
export var fileInfoWidthRestricted = "_h9-6";
export var fileType = "_h9-1";
export var fileTypeName = "_h9-2";
export var fileTypeSm = "_h9-d _h9-1";
export var image = "_h9-0";
export var link = "_h9-f";
export var overflowEllipsis = "_h9-e";